import FeaturedPages from "./featuredPages";

export default FeaturedPages;
